import {
    AnimationBaseController,
    GameRandom,
} from "../../../../modules/@denishussar/html5-game-engine";
import { Inject } from "../../../../modules/@denishussar/html5-game-engine";
import { IAnimationControllerConfiguration } from "../../../../modules/@denishussar/html5-game-engine";
import { GameModel } from "../../../Models/GameModel";
import { GameLogic } from "../../../Logic/GameLogic";
import { PopupBackgroundController } from "../../Common/PopupBackgroundController";
import { ButtonController } from "../../Common/ButtonController";

export interface ISystemScreenControllerOptions {
    type: string
}

export class SystemScreenController extends AnimationBaseController {
    $model: GameModel;

    public constructor(@Inject private _options: ISystemScreenControllerOptions,
        @Inject private _random: GameRandom,
        @Inject private _gameLogic: GameLogic) {
        super("SystemScreenController");
        console.log('SystemScreenController', this);

    }

    protected getConfiguration(): IAnimationControllerConfiguration {

        return <IAnimationControllerConfiguration>{
            childControllers: {
                ConfirmButton: {
                    instanceName: "btn_ok",
                    controller: ButtonController,
                    model: this.$model,
                    options: {
                        label: 'ok',
                        onClick: () => {
                            this._gameLogic.hideModal();
                        }
                    }
                },
            }
        };
    }

    protected onInitialize(): void {
        this.scaleX = this.scaleY = 0.66;
        if (this._options.type === 'error') {
            this.setTextByQuery('title_text', 'error');
            this.setTextByQuery('body_text', this.$model.errorMessage);
        } else {
            this.setTextByQuery('title_text', 'loading');
            this.setTextByQuery('body_text', '');
            this.$childControllers.get('ConfirmButton').visible = false;
        }

        this.addChildController({
            controller: PopupBackgroundController,
            model: this.$model
        }, "PopupBackgroundController", 0);
    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }

    protected onUpdate(frameRate: number): void {
    }
}

